module.exports = __webpack_public_path__ + "img/back_neck_depth.a4aac84a.png";